module.exports = __webpack_public_path__ + "static/learning3-91cfab6c9e0ad0a518e2a7705eaf2eda.png";